"use strict";

var _screeners = require("../../screeners");

var _utils = require("../../screeners/utils");

var surveyScreeners = [_utils.screeners.RTW_PRE_SCREENER];
var questions = (0, _screeners.expandscreeners)(surveyScreeners);

var analysis = function analysis(answers, bonus) {
  if (!answers) return null;
  var results = {};
  surveyScreeners.forEach(function (screener) {
    var filteredQuestions = questions.filter(function (question) {
      return question.batteryId === screener;
    });
    results[screener] = (0, _screeners.extractResults)(filteredQuestions, answers[screener], screener);
  });
  questions.forEach(function (q, i) {
    if (!q.key) return;
    results[q.key] = q.eval(answers[_utils.screeners.RTW_PRE_SCREENER][i], q);
  });
  return results;
};

module.exports = {
  questions: questions,
  analysis: analysis
};